import { useCurrentEditor, useEditorState } from "@tiptap/react";
import type { FC } from "react";

import { EditorButton, type EditorButtonProps } from "./editor-button";

export const EditorButtonHr: FC<EditorButtonProps> = (props) => {
  const { editor } = useCurrentEditor();
  const editorState = useEditorState({
    editor,
    selector: (ctx) => ({
      canSetHorizontalRule: ctx.editor?.can().chain().setHorizontalRule().run() ?? false,
    }),
  });

  if (!editor || !editorState) {
    return null;
  }

  return (
    <EditorButton
      {...props}
      onClick={() => editor.chain().focus().setHorizontalRule().run()}
      icon="horizontal_rule"
      tooltip="Horizontal rule"
      disabled={!editorState.canSetHorizontalRule}
    />
  );
};
